import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, LayoutGrid, Heart, ShoppingCart, User } from 'lucide-react';
import { useShop } from '../lib/shop';

const Badge = ({ n, testid }) => n > 0 ? (
  <span className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[var(--si-sale)] text-white text-[10px] font-bold flex items-center justify-center" data-testid={testid}>{n}</span>
) : null;

export const BottomNav = () => {
  const { cart, wishlistSlugs } = useShop();
  const loggedIn = !!localStorage.getItem('token');
  const cartCount = (cart?.items || []).reduce((n, it) => n + (it.qty || 1), 0);
  const items = [
    { to: '/', label: 'Home', icon: Home, end: true },
    { to: '/categories', label: 'Categories', icon: LayoutGrid },
    { to: '/wishlist', label: 'Wishlist', icon: Heart, count: wishlistSlugs.length },
    { to: '/cart', label: 'Cart', icon: ShoppingCart, count: cartCount },
    { to: loggedIn ? '/account' : '/login', label: loggedIn ? 'Account' : 'Login', icon: User },
  ];
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[var(--si-line)] shadow-[0_-2px_12px_rgba(0,0,0,0.08)]" data-testid="bottom-nav">
      <div className="max-w-3xl mx-auto grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, end, count }) => (
          <NavLink key={label} to={to} end={end} data-testid={`bottom-nav-${label.toLowerCase()}`}
            className={({ isActive }) => `relative flex flex-col items-center justify-center gap-0.5 py-2 text-[11px] md:text-xs font-semibold transition-colors ${isActive ? 'text-[var(--si-blue)]' : 'text-[var(--si-black)] hover:text-[var(--si-blue)]'}`}>
            {({ isActive }) => (
              <>
                {isActive && <span className="absolute top-0 inset-x-6 h-[3px] rounded-b bg-[var(--si-blue)]" />}
                <span className="relative"><Icon className="w-[22px] h-[22px]" strokeWidth={isActive ? 2.4 : 1.8} /><Badge n={count} testid={`bottom-nav-${label.toLowerCase()}-count`} /></span>
                {label}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
